<ng-container *ngIf="toast as t">
  <div class="system-toast-overlay">
    <div
      class="system-toast-box"
      [style.--fadeMs.ms]="fadeMs"
      [style.--holdMs.ms]="holdMs"
      role="status"
      aria-live="polite"
    >
      <div class="system-toast-body">
        <div class="system-toast-icon-wrap" aria-hidden="true">
          <svg
            class="system-toast-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18H9M17 9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9V12.5L5 15.5V16H19V15.5L17 12.5V9Z"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="system-toast-dot"></span>
        </div>

        <div class="system-toast-message">
          <span class="system-toast-label">{{ t.title || 'Error' }}:</span>
          <span>{{ t.message }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
